import axiosInstance from '../utils/axiosInstance';

export type AssessmentType = 'merits' | 'quantum';

const ENDPOINT_BY_TYPE: Record<AssessmentType, string> = {
  merits: '/raf-merits-assessment/create',
  quantum: '/raf-quantum-assessment/create',
};

export const ASSESSMENT_LABELS: Record<AssessmentType, string> = {
  merits: 'Merits Assessment',
  quantum: 'Quantum Assessment',
};

interface CreateAssessmentRequest {
  matterId: string;
  files: string[];
  representedParty?: string;
  additionalContext?: string;
  newFileMetadata?: { key: string; filename: string }[];
}

interface CreateAssessmentResponse {
  jobId: string;
  message: string;
  matterId: string;
}

export const createRafAssessment = async (
  type: AssessmentType,
  matterId: string,
  fileKeys: string[],
  options?: {
    representedParty?: string;
    additionalContext?: string;
    newFileMetadata?: { key: string; filename: string }[];
  },
): Promise<string> => {
  const body: CreateAssessmentRequest = { matterId, files: fileKeys };
  if (options?.representedParty) body.representedParty = options.representedParty;
  if (options?.additionalContext) body.additionalContext = options.additionalContext;
  if (options?.newFileMetadata) body.newFileMetadata = options.newFileMetadata;
  const response = await axiosInstance.post<CreateAssessmentResponse>(
    ENDPOINT_BY_TYPE[type],
    body,
  );
  return response.data.jobId;
};
